import "./SortIndicatorComponent.scss";
import template from "./SortIndicatorComponent.html";
import {IComponentOptions} from "angular";
import {SortingDirection} from "./SortingDirection";

export const SortIndicator = "tfSortIndicator";

export function sortIndicator(): IComponentOptions {
    return {
        template,
        bindings: {
            direction: "<"
        },
        controllerAs: "ctrl",
        controller: SortIndicatorComponentController
    };
}

export class SortIndicatorComponentController {
    public readonly direction: SortingDirection | null;
}
